/*
  EnduNAD+ Website - React Component
  Developed by Webdesign-BÖ
  Professional Web Development
  https://webdesign-boe.de
*/
import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
  const [showSpecialOffer, setShowSpecialOffer] = useState(true);
  const [openFAQ, setOpenFAQ] = useState(null);

  const affiliateLink = "https://nplink.net/e8bymdc5";
  const specialAffiliateLinkCountdown = "https://nplink.net/e8bymdc5?type=special";

  // Countdown timer
  useEffect(() => {
    if (timeLeft > 0 && showSpecialOffer) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0) {
      setShowSpecialOffer(false);
      // After 15 minutes total (5 minutes remaining), reset to special offer
      setTimeout(() => {
        setShowSpecialOffer(true);
        setTimeLeft(10 * 60);
      }, 5 * 60 * 1000); // 5 more minutes = 15 minutes total
    }
  }, [timeLeft, showSpecialOffer]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      
      {/* COUNTDOWN SPECIAL OFFER - FIRST SECTION */}
      {showSpecialOffer && (
        <section className="bg-gradient-to-r from-red-600 to-orange-500 text-white py-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-black opacity-10"></div>
          <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
            
            {/* Countdown Timer */}
            <div className="bg-white/20 backdrop-blur-md rounded-3xl p-8 mb-8 border border-white/30">
              <h1 className="text-5xl font-bold mb-4">
                🔥 SUPER ANGEBOT - NUR HEUTE! 🔥
              </h1>
              <p className="text-2xl mb-6 opacity-90">
                20% RABATT auf EnduNAD+ - Limitiertes Angebot!
              </p>
              
              <div className="bg-white text-red-600 rounded-2xl p-6 mb-6 inline-block">
                <div className="text-sm font-semibold mb-2">⏰ ANGEBOT ENDET IN:</div>
                <div className="text-6xl font-bold font-mono">{formatTime(timeLeft)}</div>
                <div className="text-sm mt-2">Minuten : Sekunden</div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                <div>
                  <img 
                    src="https://nutriprofits.com/src/template/materials/wd60twhgu9bo7edh0h3w1lgffi64ih1g.jpg" 
                    alt="EnduNAD+ SUPERANGEBOT"
                    className="w-48 h-48 mx-auto rounded-2xl shadow-2xl object-cover"
                  />
                </div>
                
                <div className="text-left">
                  <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-lg font-bold mb-4 inline-block">
                    ✅ 20% RABATT - JETZT SPAREN!
                  </div>
                  
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center justify-between bg-white/20 rounded-xl p-4">
                      <span>Normaler Preis:</span>
                      <span className="text-2xl line-through">€46.99</span>
                    </div>
                    <div className="flex items-center justify-between bg-yellow-400 text-black rounded-xl p-4">
                      <span className="font-bold">SUPER PREIS:</span>
                      <span className="text-3xl font-bold">€37.59</span>
                    </div>
                    <div className="text-center text-green-300 font-bold">
                      Sie sparen: €9.40!
                    </div>
                  </div>
                  
                  <a 
                    href={specialAffiliateLinkCountdown} 
                    className="w-full bg-yellow-400 hover:bg-yellow-300 text-black py-5 rounded-2xl text-2xl font-bold transition-all duration-300 hover:scale-105 block text-center shadow-2xl"
                  >
                    🚀 JETZT 20% SPAREN - NUR €37.59!
                  </a>
                  
                  <div className="mt-4 text-center text-yellow-200 text-sm">
                    ⚡ Begrenzte Stückzahl - Sichere dir jetzt deinen Vorrat!
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
              <div className="bg-white/10 rounded-xl p-4">
                <div className="text-2xl mb-2">🚚</div>
                <div className="font-semibold">Versand über Hersteller</div>
              </div>
              <div className="bg-white/10 rounded-xl p-4">
                <div className="text-2xl mb-2">🔒</div>
                <div className="font-semibold">Sichere Zahlung</div>
              </div>
              <div className="bg-white/10 rounded-xl p-4">
                <div className="text-2xl mb-2">⚡</div>
                <div className="font-semibold">Sofortiger Versand</div>
              </div>
            </div>
            
            <div className="mt-6 text-yellow-200 text-sm animate-pulse">
              🔥 Nur solange der Vorrat reicht - Verpasse nicht diese einmalige Chance!
            </div>
            
            <div className="mt-4 bg-white/10 rounded-xl p-4 text-center text-sm text-white/80">
              ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
            </div>
          </div>
        </section>
      )}

      {/* HERO SECTION */}
      <section className="bg-gradient-to-br from-gray-400 to-gray-600 text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            
            <div className="space-y-8">
              <h1 className="text-6xl lg:text-7xl font-bold leading-tight">
                <span className="text-blue-300">EnuNAD+</span><br/>
                Der NAD+<br/>
                Booster für<br/>
                <span className="text-purple-400">Zelluläre Energie</span>
              </h1>
              
              <p className="text-xl leading-relaxed opacity-90">
                Unterstützen Sie Ihren Körper auf zellulärer Ebene.<br/>
                EnduNAD+ erhöht den NAD+-Spiegel und<br/>
                unterstützt Energieproduktion, DNA-Reparatur und<br/>
                verlangsamt Alterungsprozesse.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xs">✓</span>
                  </div>
                  <span>Kein Energiemangel mehr</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xs">✓</span>
                  </div>
                  <span>Beschleunigte Regeneration</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xs">✓</span>
                  </div>
                  <span>Hergestellt in Europa</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xs">✓</span>
                  </div>
                  <span>Geeignet für Veganer</span>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} 
                  className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-full text-lg font-bold transition-all duration-300 hover:scale-105 text-center flex items-center justify-center gap-2"
                >
                  {showSpecialOffer ? (
                    <>
                      🎯 Bis zu 20% Rabatt erhalten!
                    </>
                  ) : (
                    <>
                      🎯 Bis zu 20% Rabatt erhalten!
                    </>
                  )}
                </a>
                <a 
                  href="#faq" 
                  className="border-2 border-white text-white hover:bg-white hover:text-gray-600 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300"
                >
                  Mehr erfahren
                </a>
              </div>
            </div>
            
            <div className="relative">
              <div className="bg-white rounded-3xl p-8 shadow-2xl">
                <img 
                  src="https://nutriprofits.com/src/template/materials/wd60twhgu9bo7edh0h3w1lgffi64ih1g.jpg" 
                  alt="EnduNAD+ Premium Supplement"
                  className="w-full max-w-md mx-auto rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Warum EnduNAD wählen? */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Warum <span className="text-purple-600">EnduNAD</span> wählen?
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              EnduNAD ist ein fortschrittlicher NAD+-Booster mit wissenschaftlich untermauterter 
              Formel. Der NAD+-Spiegel sinkt zwischen 30 und 70 Jahren um bis zu 65% - das muss 
              nicht sein!
            </p>
          </div>

          <div className="flex justify-center mb-12">
            <div className="flex flex-wrap gap-3">
              <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium">Fortschrittliche Formel</span>
              <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium">Schnell wirkende</span>
              <span className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-medium">Natürliche Inhaltsstoffe</span>
              <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full text-sm font-medium">Geeignet für Veganer</span>
              <span className="bg-red-100 text-red-800 px-4 py-2 rounded-full text-sm font-medium">Hergestellt in Europa</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            
            {/* Kein Energiemangel mehr */}
            <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto mb-6 bg-yellow-100 rounded-2xl flex items-center justify-center">
                <span className="text-3xl">⚡</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Kein Energiemangel mehr</h3>
              <p className="text-gray-600 mb-6">
                NAD+ unterstützt die zelluläre Energieproduktion und ermöglicht effiziente 
                Nährstoffumwandlung
              </p>
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full font-semibold transition-colors">
                Jetzt bestellen
              </a>
              <div className="mt-2 text-xs text-gray-500 text-center">
                ℹ️ Verkauf über Hersteller
              </div>
            </div>

            {/* Beschleunigte Regeneration */}
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto mb-6 bg-blue-100 rounded-2xl flex items-center justify-center">
                <span className="text-3xl">🔄</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Beschleunigte Regeneration</h3>
              <p className="text-gray-600 mb-6">
                Unterstützt DNA-Reparaturprozesse und PARP-Enzyme für bessere Zellregeneration
              </p>
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full font-semibold transition-colors">
                Jetzt bestellen
              </a>
              <div className="mt-2 text-xs text-gray-500 text-center">
                ℹ️ Verkauf über Hersteller
              </div>
            </div>

            {/* Kognitive Funktion */}
            <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto mb-6 bg-pink-100 rounded-2xl flex items-center justify-center">
                <span className="text-3xl">🧠</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Kognitive Funktion</h3>
              <p className="text-gray-600 mb-6">
                Fördert Gehirnfunktion, Gedächtnis und Konzentration durch Neuronen-Schutz
              </p>
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full font-semibold transition-colors">
                Jetzt bestellen
              </a>
              <div className="mt-2 text-xs text-gray-500 text-center">
                ℹ️ Verkauf über Hersteller
              </div>
            </div>

            {/* Kräftigere Muskeln */}
            <div className="bg-gradient-to-br from-yellow-50 to-amber-50 rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto mb-6 bg-yellow-100 rounded-2xl flex items-center justify-center">
                <span className="text-3xl">💪</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Kräftigere Muskeln</h3>
              <p className="text-gray-600 mb-6">
                Verbessert die Funktion der Mitochondrien und steigert die Ausdauer
              </p>
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full font-semibold transition-colors">
                Jetzt bestellen
              </a>
              <div className="mt-2 text-xs text-gray-500 text-center">
                ℹ️ Verkauf über Hersteller
              </div>
            </div>

            {/* Herz- und Gehirngesundheit */}
            <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto mb-6 bg-red-100 rounded-2xl flex items-center justify-center">
                <span className="text-3xl">❤️</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Herz- und Gehirngesundheit</h3>
              <p className="text-gray-600 mb-6">
                Unterstützt kardiovaskuläre Gesundheit und reduziert Entzündungen
              </p>
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full font-semibold transition-colors">
                Jetzt bestellen
              </a>
              <div className="mt-2 text-xs text-gray-500 text-center">
                ℹ️ Verkauf über Hersteller
              </div>
            </div>

            {/* Schutz vor Stress und Alterung */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto mb-6 bg-green-100 rounded-2xl flex items-center justify-center">
                <span className="text-3xl">🛡️</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Schutz vor Stress und Alterung</h3>
              <p className="text-gray-600 mb-6">
                Aktiviert Sirtuine für Langlebigkeit und bekämpft Zellalterung
              </p>
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full font-semibold transition-colors">
                Jetzt bestellen
              </a>
              <div className="mt-2 text-xs text-gray-500 text-center">
                ℹ️ Verkauf über Hersteller
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Wissenschaftlich untermauerte Inhaltsstoffe */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Wissenschaftlich untermauerte <span className="text-purple-600">Inhaltsstoffe</span>
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              EnduNAD+ enthält sorgfältig ausgewählte Pflanzenextrakte und Vitamine, die 
              gemeinsam die NAD+-Produktion unterstützen und die Zellgesundheit fördern.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-gray-900">Bockshornkleesamen-Extrakt</h3>
                <div className="text-right">
                  <div className="text-2xl font-bold text-purple-600">300,00 mg</div>
                  <div className="text-sm text-gray-500">[2% Trigonellin]</div>
                </div>
              </div>
              <p className="text-gray-600">
                Unterstützt die NAD+-Produktion in den Zellen und steigert die Ausdauer
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-gray-900">L-Tryptophan</h3>
                <div className="text-right">
                  <div className="text-2xl font-bold text-purple-600">200,00 mg</div>
                </div>
              </div>
              <p className="text-gray-600">
                Wesentlich für Serotonin-Produktion und NAD+-Synthese über Kynurenin-Weg
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-gray-900">Kamillenblüten-Extrakt</h3>
                <div className="text-right">
                  <div className="text-2xl font-bold text-purple-600">150,00 mg</div>
                  <div className="text-sm text-gray-500">[5% Apigenine]</div>
                </div>
              </div>
              <p className="text-gray-600">
                Hemmt NAD+-abbauende Enzyme und unterstützt emotionales Gleichgewicht
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-gray-900">Grüner Teeblatt-Extrakt</h3>
                <div className="text-right">
                  <div className="text-2xl font-bold text-purple-600">150,00 mg</div>
                  <div className="text-sm text-gray-500">[40% EGCG]</div>
                </div>
              </div>
              <p className="text-gray-600">
                Starkes Antioxidans, unterstützt Mitochondrien-Funktion
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-gray-900">Weintraubenfrucht-Extrakt</h3>
                <div className="text-right">
                  <div className="text-2xl font-bold text-purple-600">50,00 mg</div>
                  <div className="text-sm text-gray-500">[2% Resveratrol]</div>
                </div>
              </div>
              <p className="text-gray-600">
                Aktiviert Sirtuine für NAD+-Unterstützung und Langlebigkeit
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-gray-900">Niacin (Vitamin B3)</h3>
                <div className="text-right">
                  <div className="text-2xl font-bold text-purple-600">250,00 mg</div>
                  <div className="text-sm text-gray-500">[1563% NRV]</div>
                </div>
              </div>
              <p className="text-gray-600">
                Direkte NAD+-Vorstufe, unerlässlich für zelluläre Energiefunktionen
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl p-8 text-white">
            <h3 className="text-xl font-bold mb-6 text-center">✨ Zusätzliche Power-Zutaten</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <h4 className="font-bold">Alpha-Liponsäure (ALA)</h4>
                <p className="text-sm opacity-90">50mg - Starkes Antioxidans für Zellschutz</p>
              </div>
              <div>
                <h4 className="font-bold">Vitamin B6</h4>
                <p className="text-sm opacity-90">2,80mg (200% NRV) - Verstärkt Niacin-Wirkung</p>
              </div>
              <div>
                <h4 className="font-bold">BioPerine® (Piperin)</h4>
                <p className="text-sm opacity-90">2mg - Erhöht Bioverfügbarkeit um bis zu 2000%</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-full text-lg font-bold transition-colors inline-flex items-center gap-2">
              👍 EnduNAD+ jetzt bestellen
            </a>
            <div className="mt-3 text-sm text-gray-500 text-center">
              ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
            </div>
          </div>
        </div>
      </section>

      {/* Wählen Sie Ihr EnduNAD Paket */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-4">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Wählen Sie Ihr <span className="text-purple-600">EnduNAD</span> Paket
            </h2>
            <p className="text-gray-600">
              {showSpecialOffer ? "🔥 SUPER ANGEBOT: Sparen Sie bis zu 20% - Nur heute!" : "Sparen Sie mehr bei größeren Paketen"}
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Diese Seite ist eine Empfehlungsseite. Der Verkauf erfolgt über den Hersteller.
            </p>
          </div>

          <div className="flex justify-center mb-8">
            <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2">
              ℹ️ Empfehlungsseite • Verkauf über Hersteller • ⭐ 4.8/5 Sterne
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
            {/* Beliebtestes Paket */}
            <div className="relative bg-white rounded-3xl p-8 shadow-xl border-4 border-purple-500">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-purple-600 text-white px-6 py-2 rounded-full text-sm font-bold">
                  MEIST GEWÄHLT
                </span>
              </div>
              
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Beliebtestes Paket</h3>
                <img 
                  src="https://nutriprofits.com/src/template/materials/wd60twhgu9bo7edh0h3w1lgffi64ih1g.jpg" 
                  alt="6 Produkte"
                  className="w-24 h-24 mx-auto mb-4 object-cover rounded-xl"
                />
                <div className="text-sm text-gray-600 mb-2">6 Produkte</div>
                <div className="text-sm text-gray-600 mb-4">Sechsmonatslieferung</div>
                
                <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-bold mb-4">
                  {showSpecialOffer ? "20% RABATT" : "20% RABATT"}
                </div>
                
                <div className="mb-4">
                  {showSpecialOffer ? (
                    <>
                      <div className="text-4xl font-bold text-gray-900">€141.00</div>
                      <div className="text-lg text-gray-500 line-through">€281.94</div>
                      <div className="text-sm text-gray-600">(€23.50 pro Produkt)</div>
                      <div className="text-green-600 font-semibold">Sie sparen €140.94</div>
                    </>
                  ) : (
                    <>
                      <div className="text-4xl font-bold text-gray-900">€225.55</div>
                      <div className="text-lg text-gray-500 line-through">€281.94</div>
                      <div className="text-sm text-gray-600">(€37.59 pro Produkt)</div>
                      <div className="text-green-600 font-semibold">Sie sparen €56.39</div>
                    </>
                  )}
                </div>
              </div>
              
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="w-full bg-purple-600 hover:bg-purple-700 text-white py-4 rounded-xl font-bold text-lg transition-colors block text-center">
                {showSpecialOffer ? "🔥 JETZT 20% SPAREN" : "Jetzt bestellen"}
              </a>
              <div className="mt-3 text-xs text-gray-500 text-center">
                ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
              </div>
            </div>

            {/* Standard Paket */}
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Standard Paket</h3>
                <img 
                  src="https://nutriprofits.com/src/template/materials/kmnclodhscbt5rk94ua9d2ulm8r9i71d.jpg" 
                  alt="3 Produkte"
                  className="w-24 h-24 mx-auto mb-4 object-cover rounded-xl"
                />
                <div className="text-sm text-gray-600 mb-2">3 Produkte</div>
                <div className="text-sm text-gray-600 mb-4">Dreimonatslieferung</div>
                
                <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-bold mb-4">
                  {showSpecialOffer ? "20% RABATT" : "10% RABATT"}
                </div>
                
                <div className="mb-4">
                  {showSpecialOffer ? (
                    <>
                      <div className="text-4xl font-bold text-gray-900">€70.50</div>
                      <div className="text-lg text-gray-500 line-through">€140.97</div>
                      <div className="text-sm text-gray-600">(€23.50 pro Produkt)</div>
                      <div className="text-green-600 font-semibold">Sie sparen €70.47</div>
                    </>
                  ) : (
                    <>
                      <div className="text-4xl font-bold text-gray-900">€126.87</div>
                      <div className="text-lg text-gray-500 line-through">€140.97</div>
                      <div className="text-sm text-gray-600">(€42.29 pro Produkt)</div>
                      <div className="text-green-600 font-semibold">Sie sparen €14.10</div>
                    </>
                  )}
                </div>
              </div>
              
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="w-full bg-gray-800 hover:bg-gray-900 text-white py-4 rounded-xl font-bold text-lg transition-colors block text-center">
                {showSpecialOffer ? "🔥 JETZT 20% SPAREN" : "Jetzt bestellen"}
              </a>
              <div className="mt-3 text-xs text-gray-500 text-center">
                ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
              </div>
            </div>

            {/* Basispaket */}
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Basispaket</h3>
                <img 
                  src="https://nutriprofits.com/src/template/materials/pz3b2dksl5256pdsih4mz83u0lic5iy5.jpg" 
                  alt="1 Produkt"
                  className="w-24 h-24 mx-auto mb-4 object-cover rounded-xl"
                />
                <div className="text-sm text-gray-600 mb-2">1 Produkt</div>
                <div className="text-sm text-gray-600 mb-8">Einmonatslieferung</div>
                
                <div className="mb-4">
                  {showSpecialOffer ? (
                    <>
                      <div className="bg-red-100 text-red-800 px-4 py-2 rounded-full text-sm font-bold mb-4">
                        20% RABATT
                      </div>
                      <div className="text-4xl font-bold text-gray-900">€37.59</div>
                      <div className="text-lg text-gray-500 line-through">€46.99</div>
                      <div className="text-sm text-gray-600">(€37.59 pro Produkt)</div>
                      <div className="text-green-600 font-semibold">Sie sparen €23.50</div>
                    </>
                  ) : (
                    <>
                      <div className="text-4xl font-bold text-gray-900">€46.99</div>
                      <div className="text-sm text-gray-600">(€46.99 pro Produkt)</div>
                    </>
                  )}
                </div>
              </div>
              
              <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="w-full bg-gray-800 hover:bg-gray-900 text-white py-4 rounded-xl font-bold text-lg transition-colors block text-center">
                {showSpecialOffer ? "🔥 JETZT 20% SPAREN" : "Jetzt kaufen"}
              </a>
              <div className="mt-3 text-xs text-gray-500 text-center">
                ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-6 inline-block">
              <h3 className="font-bold text-gray-900 mb-4">💳 Sichere Zahlungsoptionen</h3>
              <div className="flex justify-center gap-4">
                <span className="bg-white px-4 py-2 rounded-lg border text-sm">💳 Kreditkarte</span>
                <span className="bg-white px-4 py-2 rounded-lg border text-sm">💰 SOFORT</span>
                <span className="bg-white px-4 py-2 rounded-lg border text-sm">📦 Nachnahme (+€16)</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Einfache Anwendung */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Einfache <span className="text-purple-600">Anwendung</span>
            </h2>
            <p className="text-gray-600">
              EnduNAD+ ist einfach in Ihren Tagesablauf zu integrieren. Folgen Sie den empfohlenen 
              Anweisungen für optimale Ergebnisse.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="space-y-6">
              <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-lg">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-purple-600 font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Tagesdosis</h3>
                  <p className="text-gray-600">Nehmen Sie täglich <strong>2 Kapseln</strong> EnduNAD+ ein</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-lg">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-purple-600 font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Mit Wasser</h3>
                  <p className="text-gray-600">Trinken Sie <strong>300ml Wasser</strong> zu den Kapseln</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-lg">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-purple-600 font-bold">3</span>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Wichtiger Hinweis</h3>
                  <p className="text-gray-600"><strong>Nicht auf nüchternen Magen</strong> verwenden</p>
                </div>
              </div>

              <div className="bg-green-50 rounded-2xl p-6 border border-green-200">
                <h3 className="font-bold text-green-800 mb-2">🕐 Wann wirkt EnduNAD+?</h3>
                <div className="space-y-2 text-sm text-green-700">
                  <div className="flex items-center gap-2">
                    <span className="text-green-600">✓</span>
                    <span><strong>Erste Ergebnisse:</strong> Nach wenigen Wochen regelmäßiger Einnahme</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-green-600">✓</span>
                    <span><strong>Optimale Wirkung:</strong> Nach 2-3 Monaten kontinuierlicher Anwendung</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-green-600">✓</span>
                    <span><strong>Langfristige Vorteile:</strong> Unterstützung der Zellgesundheit über längere Zeit</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <img 
                src="https://nutriprofits.com/src/template/materials/int8you849ak2ecmcmzngb0mz55a2l9m.jpg" 
                alt="EnduNAD+ 60 Kapseln"
                className="w-full max-w-md mx-auto rounded-2xl shadow-xl mb-6"
              />
              <div className="bg-white rounded-2xl p-6 shadow-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-2">EnduNAD+ 60 Kapseln</h3>
                <p className="text-gray-600 mb-2">Reicht für einen ganzen Monat</p>
                <div className="grid grid-cols-2 gap-4 text-sm mb-6">
                  <div>
                    <div className="font-semibold">Kapseln pro Packung:</div>
                    <div>60 Stück</div>
                  </div>
                  <div>
                    <div className="font-semibold">Tagesdosis:</div>
                    <div>2 Kapseln</div>
                  </div>
                  <div>
                    <div className="font-semibold">Reichweite:</div>
                    <div>30 Tage</div>
                  </div>
                  <div>
                    <div className="font-semibold">Geeignet für:</div>
                    <div>Veganer</div>
                  </div>
                </div>
                <a 
  href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink}
  className="inline-flex items-center justify-center text-center bg-purple-600 hover:bg-purple-700 text-white px-6 py-4 rounded-full font-bold transition-all w-full md:w-auto leading-none whitespace-nowrap shadow-lg"
>
  <span className="md:hidden bg-transparent">Jetzt bestellen – 20% Rabatt</span>
  <span className="hidden md:inline bg-transparent">Jetzt bestellen – Bis zu 20% Rabatt!</span>
</a>
                <div className="mt-3 text-xs text-gray-500 text-center">
                  ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Das sagen unsere Kunden */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Das sagen unsere <span className="text-orange-500">Kunden</span>
            </h2>
            <p className="text-gray-600">
              Lesen Sie NAD-NAD+ Erfahrungen von Menschen, die bereits bei Energie-
              ausgeglichenheit und Konzentration verbessert haben
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            
            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="flex items-center mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_natural-energy-boost/artifacts/xy9m22of_ChatGPT%20Image%207.%20Aug.%202025%2C%2019_03_16.png" 
                  alt="Lisa"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold">Lisa</div>
                  <div className="text-sm text-gray-500">Verifizierter Kauf</div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Mehr Energie den ganzen Tag über und deutlich besser durchschlafen."
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="flex items-center mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_natural-energy-boost/artifacts/8mqakcxu_ChatGPT%20Image%207.%20Aug.%202025%2C%2019_03_09.png" 
                  alt="Andreas"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold">Andreas</div>
                  <div className="text-sm text-gray-500">Verifizierter Kauf</div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Bin deutlich ausgeruhter. Kann arbeiten gehen ohne müde zu werden."
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="flex items-center mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_natural-energy-boost/artifacts/a63gvigd_EnduNAD_AM3.jpg" 
                  alt="Sandra"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold">Sandra</div>
                  <div className="text-sm text-gray-500">Verifizierter Kauf</div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Ich bin nur zufrieden mit dem Erzeugnis, das super funktioniert."
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="flex items-center mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_natural-energy-boost/artifacts/r5jotaqz_ChatGPT%20Image%207.%20Aug.%202025%2C%2019_03_14.png" 
                  alt="Marco"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold">Marco</div>
                  <div className="text-sm text-gray-500">Verifizierter Kauf</div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Nehme es täglich, fühle mich definitiv gut damit."
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="flex items-center mb-4">
                <img 
                  src="https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=1" 
                  alt="Julia"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold">Julia</div>
                  <div className="text-sm text-gray-500">Verifizierter Kauf</div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Endlich wieder Energie für das Training nach der Arbeit."
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6">
              <div className="flex items-center mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_natural-energy-boost/artifacts/9mn91637_ChatGPT%20Image%207.%20Aug.%202025%2C%2019_03_18.png" 
                  alt="Daniel"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold">Daniel</div>
                  <div className="text-sm text-gray-500">Verifizierter Kauf</div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Top Preis-Leistung. Ich nehme es schon jahrelang."
              </p>
            </div>
          </div>

          <div className="text-center">
            <p className="text-gray-600 mb-6">Werden auch Sie Teil der ENDUNAD Familie!</p>
            <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-bold transition-colors">
              ❤️ Jetzt EnduNAD kaufen
            </a>
            <div className="mt-3 text-sm text-gray-500 text-center">
              ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
            </div>
          </div>
        </div>
      </section>

      {/* Häufige Fragen */}
      <section id="faq" className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Häufige <span className="text-orange-500">Fragen</span>
            </h2>
            <p className="text-gray-600">
              Alles was Sie über EnduNAD wissen müssen
            </p>
          </div>

          <div className="space-y-4">
            {[
              {
                question: "Wie schnell wirkt EnduNAD?",
                answer: "Die meisten Anwender spüren bereits nach 1-2 Tagen erste Unterschiede wie mehr Energie und Ausdauer. Die vollen Erfolge entwickeln sich über mehrere Wochen regelmäßiger Einnahme."
              },
              {
                question: "Ist EnduNAD sicher und unbedenklich?",
                answer: "Ja, EnduNAD+ enthält nur natürliche Inhaltsstoffe und wird nach höchsten europäischen Qualitätsstandards hergestellt. Bei Unsicherheiten konsultieren Sie Ihren Arzt."
              },
              {
                question: "Wer kann EnduNAD verwenden?",
                answer: "EnduNAD+ ist für Erwachsene jeden Alters geeignet und ist vegan. Schwangere, Stillende und Personen mit Medikamenten sollten vorher einen Arzt konsultieren."
              },
              {
                question: "Gibt es Nebenwirkungen?",
                answer: "EnduNAD+ ist in der Regel sehr gut verträglich. In seltenen Fällen können leichte Magenbeschwerden auftreten, weshalb die Einnahme mit Nahrung empfohlen wird."
              },
              {
                question: "Wie lange reicht eine Packung EnduNAD?",
                answer: "Eine Packung EnduNAD+ enthält 60 Kapseln und reicht bei der empfohlenen Tagesdosis von 2 Kapseln für 30 Tage."
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <span className="text-lg font-semibold text-gray-900">{faq.question}</span>
                  <span className={`text-orange-500 transform transition-transform duration-200 ${openFAQ === index ? 'rotate-180' : ''}`}>
                    ▼
                  </span>
                </button>
                {openFAQ === index && (
                  <div className="px-8 pb-6">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 mb-6">Haben Sie weitere Fragen? Kontaktieren Sie uns gerne!</p>
            <a href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-full text-lg font-bold transition-colors">
              EnduNAD jetzt bestellen
            </a>
            <div className="mt-3 text-sm text-gray-500 text-center">
              ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
            </div>
          </div>
        </div>
      </section>

      {/* Bereit für mehr Energie? */}
      <section className="py-16 bg-gradient-to-r from-orange-500 to-red-500 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Bereit für mehr <span className="text-yellow-300">Energie?</span>
          </h2>
          <p className="text-xl mb-12 opacity-90">
            Schließen Sie sich tausenden zufriedenen Kunden an und erleben Sie, wie 
            EnduNAD+ Ihr Leben verbessert. Spätestens, weniger müde Nachmittage.
          </p>
          
          <div className="bg-white/20 backdrop-blur-md rounded-2xl p-6 mb-8">
            <img 
              src="https://nutriprofits.com/src/template/materials/wd60twhgu9bo7edh0h3w1lgffi64ih1g.jpg" 
              alt="EnduNAD+ Bereit für mehr Energie"
              className="w-32 h-32 mx-auto rounded-xl object-cover mb-4"
            />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="flex items-center justify-center gap-2">
                <span className="text-green-300">✓</span>
                <span>Sichere Zahlung</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <span className="text-green-300">✓</span>
                <span>Verkauf über Hersteller</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <span className="text-green-300">✓</span>
                <span>Diskrete Lieferung</span>
              </div>
            </div>
          </div>
          
          <a 
            href={showSpecialOffer ? specialAffiliateLinkCountdown : affiliateLink} 
            className="inline-block bg-yellow-400 hover:bg-yellow-300 text-black px-12 py-5 rounded-2xl text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300"
          >
            {showSpecialOffer ? "🔥 ENDUNAD JETZT 20% GÜNSTIGER BESTELLEN" : "🚀 ENDUNAD JETZT BESTELLEN"}
          </a>
          
          <div className="mt-4 text-sm text-white/80 text-center">
            ℹ️ Der Versand erfolgt direkt über den Hersteller. Die Versandkosten hängen vom Zielland ab und werden beim Bestellabschluss angezeigt.
          </div>
          
          <div className="mt-6 text-sm opacity-75">
            🚨 Limitiertes Angebot - Nur noch wenige Packungen verfügbar!
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            
            {/* ENDUNAD */}
            <div>
              <h3 className="text-xl font-bold text-orange-400 mb-4">ENDUNAD</h3>
              <p className="text-gray-400 leading-relaxed text-sm">
                Das natürliche Nahrungsergänzungsmittel für mehr Energie, bessere Konzentration und verbessertes Wohlbefinden.
              </p>
            </div>
            
            {/* Wichtige Links */}
            <div>
              <h3 className="text-xl font-bold text-orange-400 mb-4">Wichtige Links</h3>
              <ul className="space-y-3 text-gray-400 text-sm">
                <li><a href="#" className="hover:text-white transition-colors">EnduNAD kaufen</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Erfahrungen</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Produktinfos</a></li>
              </ul>
            </div>
            
            {/* Vorteile */}
            <div>
              <h3 className="text-xl font-bold text-orange-400 mb-4">Vorteile</h3>
              <ul className="space-y-3 text-gray-400 text-sm">
                <li className="flex items-center gap-2">
                  <span className="text-green-400">✓</span>
                  <span>Energie steigern</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-green-400">✓</span>
                  <span>Konzentration steigern</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-green-400">✓</span>
                  <span>Wohlbefinden verbessern</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-green-400">✓</span>
                  <span>Natürliche Inhaltsstoffe</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <p className="text-gray-500 text-sm">
              © 2024 Alle Rechte vorbehalten.
            </p>
            <p className="text-gray-600 text-xs mt-2">
              Website entwickelt von <span className="text-orange-400">Webdesign-BÖ</span>
            </p>
          </div>
        </div>
      </footer>

    </div>
  );
}

export default App;